import React from "react";
import IndustryPage from "./IndustryPage";

const TelecommunicationsPage: React.FC = () => {
  return <IndustryPage industryKey="telecommunications" />;
};

export default TelecommunicationsPage;
